@if (filteredItems?.length && filteredItems?.length > pageSizeOptions[0]) {
  <div class="container">
    <div class="paginator-holder">
      <div class="paginator-container">
        <mat-paginator
          (page)="loadPage($event)"
          [length]="filteredItems ? filteredItems.length : 0"
          [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="currentEvent.pageIndex"
          [showFirstLastButtons]="!isMobile"
        [pageSize]="currentEvent.pageSize"></mat-paginator>
      </div>
    </div>
  </div>
}
